import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import qs from 'query-string';

import { programBoardList, nicknameUpdate } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import LocalText from '@/localization/local_text';
import GoogleAuth from './GoogleAuth';
import useContent from '@/localization/data_export';
import './css/common_program_board.scss';

function CommonProgramBoard(props) {
  const { mode, title, setSubLocation } = props;
  const location = useLocation();

  const anchorTitle = useContent(['global', 'anchor', 'title']);
  const parsed = qs.parse(location.search);

  const type = parsed.type;
  const rowsPerPage = 10;
  const [, , , , boardId] = location.pathname.split('/');

  const [page, setPage] = useState(0);
  const [menuTitle, setMenuTitle] = useState('');
  const [loginModal, setLoginModal] = useState(false);
  const [memberRadio, setMemberRadio] = useState(0);
  const [nickNameValue, setNickNameValue] = useState('');
  const [nickChangeMode, setNickChangeMode] = useState(false);

  const [boardData, setBoardData] = useState({
    board_id: boardId,
    lan_code: mode,
    hit: true,
    reg_order: 'desc',
    page_info: {
      row_count: rowsPerPage,
      number: page,
    },
  });

  const [listData, setListData] = useState({
    lan_code: mode,
    board_id: boardId,
    program_type: 'tv',
    type: 'aod',
    reg_order: 'desc',
    page_info: { row_count: rowsPerPage, number: page },
  });

  const [boardItem] = useAxios(programBoardList, [boardData], boardData, true);
  const [topBoardItem] = useAxios(
    programBoardList,
    [boardData],
    { ...boardData, key_word: 'top_allow', page_info: { row_count: -1, number: 0 } },
    true
  );

  const { data } = boardItem;
  const { data: topItemList } = topBoardItem;

  const nickHandler = (e) => {
    setNickNameValue(e.target.value);
  };

  const handleLogout = () => {
    localStorage.removeItem('userData');
    setNickChangeMode(false);
    setLoginModal(false);
    mode === 'ko' ? alert('로그아웃 되었습니다.') : alert('Logout Succesed');
  };

  const handleNickChang = (nickName) => {
    if (nickName) {
      nicknameUpdate({ nick_name: nickName })
        .then((res) => {
          localStorage.setItem(
            'userData',
            JSON.stringify({
              token: res.data.resultCode.access_token.slice(7),
              nickName: res.data.nick_name,
            })
          );
          mode === 'ko' ? alert('정상적으로 변경되었습니다.') : alert('Changed Succesed');
          setNickChangeMode(false);
          setLoginModal(false);
        })
        .catch(() => {
          mode === 'ko' ? alert('닉네임 변경에 실패하였습니다.') : alert('Failed to change nickname.');
        });
    } else {
      mode === 'ko' ? alert('닉네임을 입력해주세요.') : alert('Enter the nickname');
    }
  };

  useEffect(() => {
    if (title) {
      const filtItem = title?.data?.item?.filter((el) => el.board_id === parseInt(boardId))?.[0];
      setMenuTitle(filtItem?.title);
    }
    if (type) {
    }
  }, [type, title, boardId]);

  useEffect(() => {
    setPage(0);
    setBoardData({
      ...boardData,
      board_id: location.pathname.split('/')[4],
      page_info: { row_count: 10, number: 0 },
    });
    setListData({
      ...listData,
      board_id: location.pathname.split('/')[4],
      page_info: { row_count: 10, number: 0 },
    });
  }, [boardId]);

  useEffect(() => {
    setSubLocation(location.pathname);
  }, []);

  return (
    <div id="CommonProgramBoard" className="commonProgramBoard">
      {loginModal && (
        <div className="commonProgramBoard_modal">
          {nickChangeMode ? (
            <div className="nickchange">
              <div className="nickchange_top-warp">
                <div className="nickchange_top-warp_setting">
                  <img
                    className="nickchange_top-warp_setting imgbox"
                    src={require('@/assets/images/icon/setting.png').default}
                    alt="nink_change_img"
                  ></img>
                  <label className="nickchange_top-warp_setting label">{mode === 'en' ? ' Setting' : ' 설정'}</label>
                </div>
                <button type="button" className="nickchange_top-warp_btn type1" onClick={() => handleLogout()}>
                  {mode === 'en' ? 'Logout' : '로그아웃'}
                </button>
              </div>
              <h2 className="nickchange_title">{mode === 'en' ? 'Change Nickname' : '닉네임 변경'}</h2>
              <div className="nickchange_input">
                <div className="nickchange_input_nick">
                  <label htmlFor="inputNick" className="nickchange_input_nick_label">
                    {mode === 'en' ? 'Nickname' : '닉네임'}
                  </label>
                  <input
                    type="text"
                    id="inputNick"
                    className="nickchange_input_nick_text"
                    onChange={(e) => nickHandler(e)}
                  />
                </div>
              </div>
              <div className="nickchange_btn-warp">
                <button type="button" className="nickchange_btn-warp_btn type2" onClick={() => setLoginModal(false)}>
                  {mode === 'en' ? 'Cancel' : '취소'}
                </button>
                <button
                  type="button"
                  className="nickchange_btn-warp_btn type2"
                  onClick={() => handleNickChang(nickNameValue)}
                >
                  {mode === 'en' ? 'Modify' : '변경'}
                </button>
              </div>
            </div>
          ) : (
            <div className="login">
              <h2 className="login_title">
                <LocalText txt={'radio_livechat_pop_title'} />
              </h2>
              <p className="login_title-sub">
                <LocalText txt={'radio_livechat_pop_sub'} />
              </p>
              <div className="login_btn-member">
                <button
                  type="button"
                  className={`login_btn-member_btn ${memberRadio === 1 && 'on'}`}
                  onClick={() => setMemberRadio(1)}
                >
                  {mode === 'en' ? 'Yes' : '예'}
                </button>
                <button
                  type="button"
                  className={`login_btn-member_btn ${memberRadio === 0 && 'on'}`}
                  onClick={() => setMemberRadio(0)}
                >
                  {mode === 'en' ? 'No' : '아니오'}
                </button>
              </div>
              {memberRadio === 0 && (
                <div className="login_input_nick">
                  <label htmlFor="inputNick" className="login_input_nick_label">
                    Nickname
                  </label>
                  <input
                    type="text"
                    id="inputNick"
                    className="login_input_nick_text"
                    onChange={(e) => nickHandler(e)}
                  />
                </div>
              )}
              <div className="login_btn-warp">
                <GoogleAuth nickNameValue={nickNameValue} memberRadio={memberRadio} setLoginModal={setLoginModal} />
              </div>
              <div className="login_btn-warp">
                <button type="button" className="login_btn-warp_btn type" onClick={() => setLoginModal(false)}>
                  <LocalText txt={'radio_livechat_pop_cancel'} />
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="commonProgramBoard_content">
        {/* ProgramBoard && Announcement*/}
        {type !== 'write' && (
          <table className="table">
            <caption className="sr-only">{menuTitle}</caption>
            <colgroup>
              <col width="8%" />
              <col width="12%" />
              <col width="*" />
              <col width="8%" />
            </colgroup>
            <thead className="table_head">
              <tr className="table_row">
                <th className="table_row_head" scope="col">
                  NO
                </th>
                <th className="table_row_head" scope="col">
                  DATE
                </th>
                <th className="table_row_head" scope="col">
                  Title
                </th>
                <th className="table_row_head" scope="col">
                  HIT
                </th>
              </tr>
            </thead>
            <tbody className="table_body">
              {topItemList?.item.map((v) => {
                return (
                  <tr className="table_row" key={v.board_item_id} style={{ fontWeight: 'bold' }}>
                    <td className="table_row_data" style={{ textAlign: 'center' }}>
                      TOP
                    </td>
                    <td className="table_row_data" style={{ textAlign: 'center' }}>
                      {v.reg_date.substring(10, 2)}
                    </td>
                    <td className="table_row_data">
                      <Link to={`${location.pathname}/${v.board_item_id}`} className="link" title={anchorTitle}>
                        {v.title}
                      </Link>
                    </td>
                    <td className="table_row_data" style={{ textAlign: 'center' }}>
                      {v.hit_count}
                    </td>
                  </tr>
                );
              })}
              {data
                ? data?.item.map((v, i) => {
                    return (
                      !v.is_top && (
                        <tr className={`table_row ${v.is_top && ''}`} key={v.board_item_id}>
                          <td className="table_row_data style_center">
                            {data?.paging_info?.total_item_count - rowsPerPage * page - i}
                          </td>
                          <td className="table_row_data style_center">{v.reg_date.substring(10, 2)}</td>
                          <td className="table_row_data">
                            <Link to={`${location.pathname}/${v.board_item_id}`} className="link" titel={anchorTitle}>
                              {v.title}
                            </Link>
                          </td>
                          <td className="table_row_data style_center">{v.hit_count}</td>
                        </tr>
                      )
                    );
                  })
                : null}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default CommonProgramBoard;
